import { RemoteCreatePartnerRequest } from 'data/usecases/partners';
import { makeApiUrlPartnerRequests } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreatePartnerRequest = (): RemoteCreatePartnerRequest => {
  return new RemoteCreatePartnerRequest(
    makeApiUrlPartnerRequests(),
    makeAxiosHttpClient(),
  );
};
